import { MemeGeneratorState } from "../../types";

interface Payload {
    payload: MemeGeneratorState["recentlyUsedFonts"]["list"];
}

export const setRecentlyUsedFonts = (state: MemeGeneratorState, { payload }: Payload) => {
    state.recentlyUsedFonts.list = payload;
};
